import { delegate, uid } from '@dabble/app';
import { ACCOUNT_URL } from './global-constants';

// `uid`/`impersonate` selects the account; identity itself rides the shared
// `.dabblewriter.com` cookie. `redirect` brings the user back here.
function accountUrl(path: string) {
  const url = new URL(path, ACCOUNT_URL);
  const currentUid = uid.get();
  if (currentUid) url.searchParams.set(delegate ? 'impersonate' : 'uid', currentUid);
  url.searchParams.set('redirect', location.href);
  return url.toString();
}

export const profileUrl = () => accountUrl('account/profile');
export const billingPortalUrl = () => accountUrl('billing/portal');
export const planPickerUrl = () => accountUrl('billing/plans');
